export type CanvasPanZoom = {
  zoom: number;
  panX: number;
  panY: number;
};

/**
 * Pointer-anchored multiplicative zoom. Pure so the high-frequency gesture
 * path can run imperatively without reading React/Redux state.
 */
export function computeWheelZoomViewport(
  current: CanvasPanZoom,
  pointer: { x: number; y: number },
  deltaY: number,
  minZoom: number,
  maxZoom: number
): CanvasPanZoom {
  const oldScale = Math.max(current.zoom, 1e-9);
  const worldX = (pointer.x - current.panX) / oldScale;
  const worldY = (pointer.y - current.panY) / oldScale;
  const direction = deltaY > 0 ? -1 : 1;
  const zoom = Math.max(minZoom, Math.min(maxZoom, oldScale * (1 + direction * 0.1)));
  return {
    zoom,
    panX: pointer.x - worldX * zoom,
    panY: pointer.y - worldY * zoom,
  };
}

